export const VALID_ACADEMY_RESOURCE_TYPES = [
  'Best practices',
  'Certificate',
  'Course',
  'Getting started',
  'Live training',
  'Quick guide',
];

export const VALID_ACADEMY_RESOURCE_LANGUAGES = [
  'English',
  'French',
  'Spanish',
];
